import ButtonIcon from './ButtonIcon';

export default ButtonIcon;
